var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"form"},[_c('v-row',[_c('v-col',[_c('v-text-field',{attrs:{"label":_vm.$t('name'),"outlined":"","dense":"","value":_vm.name,"hide-details":"auto","rules":[_vm.isRequired]},on:{"input":function($event){return _vm.$emit('update:name', $event)}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }